import { useContext, useEffect, useState } from "react";
import { Colour } from "../Variables";
import { Card } from "../components/Shared/Card";
import { RouteContext } from "../../contexts/RoutesContext";
import { API_GetEmailAlreadyAppliedWarning } from "../../apis/ApisEmailAlreadyApplied";

export function EmailAlreadyApplied() {
    const routeContext = useContext(RouteContext);
    const [warning, setWarning] = useState<string>("");

    useEffect(() => {
        routeContext.setRoutes([{ name: "Unable to apply", route: null }]);
    }, []);

    useEffect(() => {
        (async () => {
            const data = await API_GetEmailAlreadyAppliedWarning();
            setWarning(data?.Warning ?? "");
        })();
    }, []);

    return (
        <Card title={"Unable to apply"} headerTheme={Colour.Alt} headerClasses={""} >
            <div className="p-3">{warning}</div>
        </Card>
    );
}
